import { VariantAttribute } from "@swo/shared";
import { PDPInternalState, PDPSwarovskiProductFrontend, PDPSwarovskiProductVariantFrontend } from "./types";
import { selectVariantForAttributes } from "./select-variant-for-attributes";

export function selectVariantForAttributesState(
  selectedProduct: PDPSwarovskiProductFrontend,
  desiredAttributesSelection: Array<VariantAttribute>,
  stickyAttributesSelectionIndex: number | undefined,
): Pick<PDPInternalState, "selectedVariant" | "attributesSelection"> {
  const { variant } = selectVariantForAttributes(selectedProduct, {
    desiredAttributesSelection,
    stickyAttributesSelectionIndex,
  });

  return {
    selectedVariant: variant,
    attributesSelection: variant.attributes.unique || [],
  };
}
